/**
 * `?return=` on the public sign page may only point back into the customer
 * portal. Anything else (absolute URLs, protocol-relative, other app routes)
 * is dropped so the parameter can never become an open redirect.
 */
const PORTAL_PATH = /^\/portal\/[A-Za-z0-9_-]+(\/.*)?$/;

export function safeReturnTo(raw: string | null | undefined): string | null {
  if (!raw) return null;
  const value = raw.trim();
  if (!PORTAL_PATH.test(value)) return null;
  if (value.startsWith('//') || /[\r\n]/.test(value)) return null;
  return value;
}

export const PORTAL_LAST_SLUG_KEY = 'portal:last_slug';

export function rememberPortalSlug(slug: string): void {
  try {
    localStorage.setItem(PORTAL_LAST_SLUG_KEY, slug);
  } catch {
    // storage unavailable — the /portal index just shows the neutral card
  }
}

export function lastPortalSlug(): string | null {
  try {
    const v = localStorage.getItem(PORTAL_LAST_SLUG_KEY);
    return v && /^[A-Za-z0-9_-]+$/.test(v) ? v : null;
  } catch {
    return null;
  }
}
